import api from './Api'

const route = '/locations'

export default {
  get: params => api().get(`${route}`, { params }),
  getAll: () => api().get(`${route}`, { params: { 'per-page': 100 } }),
  view: params => api().get(`${route}/${params.id}`, { params }),
  getLocationDealer: params => api().get(`${route}/dealer-locations/${params.id}`, { params }),
  post: (payload, params) => api().post(`${route}`, payload, { params }),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  delete: payload => api().delete(`${route}/${payload.id}`),
  addEstadoProceso: (payload, params) => api().post(`${route}/${payload.id}/add-estado-proceso`, payload, { params }),
  getPartnerLocations: () => api().get(`${route}/partner-locations`)
  // enable: payload => api().put(`${route}/enable/${payload.id}`),
  // getStats: () => api().get(`${route}/stats`)
}
